import React from 'react'
import PropTypes from 'prop-types'
import Breadcrumb from '@lmc/ui-kit/src/navigation/Breadcrumb/Breadcrumb'
import { history } from '../../../../../../store'

export default function MedStockBreadcrumb(props) {
  const { medication } = props
  const { Item } = Breadcrumb

  return (
    <Breadcrumb>
      <Item>
        <a
          // href={`/residents/${medication.resident}/emar/${medication.id}`}
          onClick={() => {
            history.push(
              `/residents/${medication.resident}/emar/${medication.id}/chart`
            )
          }}
          // target="_blank"
        >
          {medication.name}
        </a>
      </Item>
      <Item>Stock</Item>
    </Breadcrumb>
  )
}

MedStockBreadcrumb.propTypes = {
  medication: PropTypes.object.isRequired
}
